import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.news-feature').forEach(function (block) {
        var el = block.querySelector('.splide');
        if (!el) return;

        var splide = new Splide(el, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: true,
            autoplay: false,
            gap: 0,
        });

        splide.on('mounted', function () {
            var paginationEl = el.querySelector('.splide__pagination');
            var dotsContainer = block.querySelector('.nf-dots');

            if (paginationEl && dotsContainer) {
                dotsContainer.appendChild(paginationEl);
            }
        });

        splide.mount();

        var prevBtn = block.querySelector('.nf-arrow-prev');
        var nextBtn = block.querySelector('.nf-arrow-next');

        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                splide.go('<');
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                splide.go('>');
            });
        }
    });
});
